import { serializeDripComponents, visualizeDripComponents } from "@/assets/utilities/tinymce/visualization/dripForm";
import { serializeCheckoutForm, visualizeCheckoutForm } from "@/assets/utilities/tinymce/visualization/checkoutForm";
import {
  serializeEmailFormComponents,
  visualizeEmailFormComponents,
} from "@/assets/utilities/tinymce/visualization/emailForm";
import {
  serializeContactFormComponent,
  visualizeContactFormComponent,
} from "@/assets/utilities/tinymce/visualization/contactForm";
import { olListCustomNumeric } from "@/assets/utilities/tinymce/visualization/olNumericList";
import {
  serializeCommentsWidget,
  visualizeCommentsWidget,
} from "@/assets/utilities/tinymce/visualization/commentsWidget";
import { serializeMultiStepQuiz, visualizeMultiStepQuiz } from "@/assets/utilities/tinymce/visualization/multiStepQuiz";
import {
  serializeMultiStepQuizV2,
  visualizeMultiStepQuizV2,
} from "@/assets/utilities/tinymce/visualization/multiStepQuizV2";
import { serializeTimer, visualizeTimer } from "./timer";
import { serializeToast, visualizeToast } from "@/assets/utilities/tinymce/visualization/toast";
import { serializeLiveChat, visualizeLiveChat } from "@/assets/utilities/tinymce/visualization/liveChat";
import { visualizeLiveAutoChat, serializeLiveAutoChat } from "@/assets/utilities/tinymce/visualization/liveChatAuto";
import { serializeAudioForm, visualizeAudioForm } from "@/assets/utilities/tinymce/visualization/audioForm";
import { serializeBottomBar, visualizeBottomBar } from "@/assets/utilities/tinymce/visualization/bottomBar";
import { serializeCounter, visualizeCounter } from "./counter";
import { serializeCarrierNames, visualizeCarrierNames } from "@/assets/utilities/tinymce/visualization/carrierNames";
import { serializeZipCodeShortcode, visualizeZipCodeShortcode } from "@/assets/utilities/tinymce/visualization/zipCode";
import { serializeMultiStepQuizV3, visualizeMultiStepQuizV3 } from "./multiStepQuizV3";
import { serializeMultiStepQuizV4, visualizeMultiStepQuizV4 } from "./multiStepQuizV4";
import { serializeButtonsWithTextBox, visualizeButtonsWithTextBox } from "./buttonsWithTextBox";
/**
 * Serializes shortcodes data
 * e.g.
 * <div data-multi-step-quiz-data="">
 *                  ->
 * <multistep-quiz :quiz-data=""></multistep-quiz>
 * @param {Element} content HAS TO BE PASSED BY REFERENCE TO BE MUTATED PROPERLY
 */
export const serializeDynamicComponents = content => {
  serializeDripComponents(content);
  serializeCheckoutForm(content);
  serializeEmailFormComponents(content);
  serializeContactFormComponent(content);
  olListCustomNumeric(content);
  serializeCommentsWidget(content);
  serializeMultiStepQuiz(content);
  serializeMultiStepQuizV2(content);
  serializeMultiStepQuizV3(content);
  serializeMultiStepQuizV4(content);
  serializeTimer(content);
  serializeToast(content);
  serializeLiveChat(content);
  serializeLiveAutoChat(content);
  serializeAudioForm(content);
  serializeBottomBar(content);
  serializeCounter(content);
  serializeCarrierNames(content);
  serializeZipCodeShortcode(content);
  serializeButtonsWithTextBox(content);
};

export const visualizeDynamicComponents = content => {
  visualizeDripComponents(content);
  visualizeCheckoutForm(content);
  visualizeEmailFormComponents(content);
  visualizeContactFormComponent(content);
  visualizeCommentsWidget(content);
  visualizeMultiStepQuiz(content);
  visualizeMultiStepQuizV2(content);
  visualizeMultiStepQuizV3(content);
  visualizeMultiStepQuizV4(content);
  visualizeTimer(content);
  visualizeToast(content);
  visualizeLiveChat(content);
  visualizeLiveAutoChat(content);
  visualizeAudioForm(content);
  visualizeBottomBar(content);
  visualizeCounter(content);
  visualizeCarrierNames(content);
  visualizeZipCodeShortcode(content);
  visualizeButtonsWithTextBox(content);

  content.querySelectorAll(".columns").forEach(element => {
    element.classList.add("dash-highlight");
  });
};
